import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';
import { supabase } from '../supabase.js';
import type { AdminRole } from '@monigo/shared';

interface SessionState {
  session: Session | null;
  user: User | null;
  role: AdminRole | null;
  loading: boolean;
  init(): Promise<void>;
  signOut(): Promise<void>;
}

function readRole(session: Session | null): AdminRole | null {
  return (session?.user.app_metadata?.app_role ?? null) as AdminRole | null;
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  user: null,
  role: null,
  loading: true,
  async init() {
    const { data } = await supabase.auth.getSession();
    set({
      session: data.session,
      user: data.session?.user ?? null,
      role: readRole(data.session),
      loading: false,
    });
    supabase.auth.onAuthStateChange((_evt, session) => {
      set({ session, user: session?.user ?? null, role: readRole(session) });
    });
  },
  async signOut() {
    await supabase.auth.signOut();
    set({ session: null, user: null, role: null });
  },
}));

export function hasRole(current: AdminRole | null, allowed: AdminRole[]): boolean {
  return current != null && allowed.includes(current);
}
